import { render, staticRenderFns } from "./spareProcurement.vue?vue&type=template&id=b139e9ec&scoped=true&"
import script from "./spareProcurement.vue?vue&type=script&lang=js&"
export * from "./spareProcurement.vue?vue&type=script&lang=js&"
import style0 from "./spareProcurement.vue?vue&type=style&index=0&id=b139e9ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b139e9ec",
  null
  
)

export default component.exports